<template>
  <div class="auth-cabinet ts-site">
    <header>
      <component :is="shell.header" />
      <div v-if="showLanguageBar" id="cabinet-language-bar" class="ts-app ts-subnav">
        <div class="ts-subnav-bar">
          <div class="container d-flex justify-content-end">
            <language-header-themes />
          </div>
        </div>
      </div>
    </header>
    <main id="content" class="ts-app">
      <!-- Talentspace sites: the same bar as on every other page (sections, account menu, notebook, language) -->
      <pages-navigation v-if="isTalentspace" />
      <!-- The cabinet is a work area (CRM iframe): on Talentspace sites it takes the full width -->
      <div :class="isTalentspace ? 'container-fluid p-2 p-lg-3' : 'container pt-0 pb-5'">
        <router-view />
      </div>
    </main>
    <component :is="shell.footer" />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import LanguageHeaderThemes from '@/components/Layout/LanguageHeaderThemes.vue';
import PagesNavigation from '@/components/Layout/PagesNavigation.vue';
import { AppModule } from '@/store/modules/app';
import { group } from '@/config/configuration';
import { isTalentspaceSite, siteShell } from '@/sites';

// Cabinet with the site's header and footer (the full-page variant is CabinetBlankTemplate)
@Component({
  components: { LanguageHeaderThemes, PagesNavigation },
})
export default class CabinetTemplate extends Vue {
  get sid() {
    return AppModule.sid;
  }

  get shell() {
    return siteShell(this.sid);
  }

  get isTalentspace() {
    return isTalentspaceSite(this.sid);
  }

  // Theme headers (except amseu) have no language switch, so the cabinet adds it as a separate bar
  get showLanguageBar() {
    return !this.isTalentspace && group(this.sid) && this.sid !== 'amseu';
  }

  // The legacy portal styles (body.portal) don't belong on a Talentspace site — they put the old
  // .nav-link borders into the client header. mounted, not created: the DefaultTemplate we come
  // from adds the class back in its beforeDestroy, which runs after our created.
  mounted() {
    document.body.classList.toggle('portal', !this.isTalentspace);
  }
}
</script>
